module.exports = __webpack_public_path__ + "img/redBell.607f10ca.png";